// Sygnaly Consent Mode v2 -> idName grupy cookies z banera (CookieItem w API)
export const CONSENT_GROUPS = {
  ad_storage: 'marketing',
  ad_user_data: 'marketing',
  ad_personalization: 'marketing',
  analytics_storage: 'analytics',
  functionality_storage: 'functionality',
  personalization_storage: 'functionality',
  security_storage: 'security',
}

const CONSENT_DEFAULT = {
  ad_storage: 'denied',
  ad_user_data: 'denied',
  ad_personalization: 'denied',
  analytics_storage: 'denied',
  functionality_storage: 'denied',
  personalization_storage: 'denied',
  security_storage: 'granted',
  wait_for_update: 500,
}

// GTM-XXXX -> kontener Tag Managera (gtm.js), G-XXXX -> GA4 bezposrednio (gtag/js)
export const getGoogleTag = (rawId) => {
  const id = typeof rawId === 'string' ? rawId.trim().toUpperCase() : ''

  if (/^GTM-[A-Z0-9]+$/.test(id)) {
    return { id, type: 'gtm' }
  }

  if (/^G-[A-Z0-9]+$/.test(id)) {
    return { id, type: 'gtag' }
  }

  return null
}

const toInlineJson = (value) => JSON.stringify(value).replace(/</g, '\\u003c')

// Nazwa cookie GA4 dla naszego identyfikatora (G-XXXX -> _ga_XXXX); dla GTM identyfikator GA4 jest w kontenerze
export const getOwnGaCookieName = (tag) => (tag?.type === 'gtag' ? `_ga_${tag.id.slice(2)}` : null)

// Zgoda domyslna, zgoda zapisana w cookie_preferences (powracajacy uzytkownik) i dopiero potem loader,
// zeby tag nigdy nie wystartowal przed ustawieniem stanu zgod.
// hostOnlyCookies: cookies GA tylko na biezacym hoscie (domeny czasopism, np. *.uw.edu.pl), a nie na domenie nadrzednej.
export const getGoogleTagScript = (tag, cookiesLastUpdatedAt, { hostOnlyCookies = false } = {}) => {
  const configParams = hostOnlyCookies ? `, ${toInlineJson({ cookie_domain: 'none' })}` : ''
  const loader =
    tag.type === 'gtm'
      ? `dataLayer.push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' });
  var src = 'https://www.googletagmanager.com/gtm.js?id=' + tagId;`
      : `gtag('js', new Date());
  gtag('config', tagId${configParams});
  var src = 'https://www.googletagmanager.com/gtag/js?id=' + tagId;`

  return `
  window.dataLayer = window.dataLayer || [];
  function gtag() { dataLayer.push(arguments); }
  (function () {
  var tagId = ${toInlineJson(tag.id)};
  gtag('consent', 'default', ${toInlineJson(CONSENT_DEFAULT)});
  try {
    var match = document.cookie.match(/(?:^|; )cookie_preferences=([^;]*)/);
    var stored = match ? JSON.parse(decodeURIComponent(match[1])) : null;
    if (stored && stored.lastUpdatedAt === ${toInlineJson(cookiesLastUpdatedAt ?? null)} && Array.isArray(stored.items)) {
      var groups = ${toInlineJson(CONSENT_GROUPS)};
      var update = {};
      Object.keys(groups).forEach(function (signal) {
        update[signal] = stored.items.some(function (item) {
          return item.idName === groups[signal] && item.isAccepted;
        })
          ? 'granted'
          : 'denied';
      });
      gtag('consent', 'update', update);
    }
  } catch (e) {}
  ${loader}
  var script = document.createElement('script');
  script.async = true;
  script.src = src;
  document.head.appendChild(script);
  })();`
}
